import { useFeatureValue, useFeatureIsOn } from '@growthbook/growthbook-react';

export const ToDisplayFeatureFlagged = (
  flagName: string,
  featureToBeDisabled: boolean
): boolean => {
  const isFeatureEnabled = useFeatureIsOn(flagName);
  const featureFlag = useFeatureValue(flagName, false);

  const toDisplay = isFeatureEnabled && featureFlag;

  return featureToBeDisabled ? !toDisplay : toDisplay;
};
